import { Tooltip } from '@gravity-ui/uikit';
import { EDIT_BLANK } from 'features/admin-mode/constants';
import { EstablishmentEditModal } from '../modals/establishment-edit-modal';

import styles from './styles.module.scss';
import { EstablishmentEditSheet } from '../sheets/establishment-edit-sheet';

export const AdminEstablishmentsListBlock = ({ establishment, onAdd, isMobile }: any) => {
	return (
		<div key={establishment.id} className={styles.list_block}>
			<div className={styles.list_block__user}>
				<div className={styles.list_block__user__info}>
					<h3>Учреждение</h3>
					<p>{establishment?.name ?? '—'}</p>
				</div>
			</div>
			<div className={styles.list_block__panel}>
				<Tooltip
					className={styles.blankTable__action__tooltip}
					content={EDIT_BLANK}
					placement="top"
					openDelay={500}
				>
					<div tabIndex={0}>
						{isMobile ? (
							<EstablishmentEditSheet
								establishment={establishment}
								onAdd={onAdd}
								key={establishment.id}
							/>
						) : (
							<EstablishmentEditModal
								establishment={establishment}
								onAdd={onAdd}
								key={establishment.id}
							/>
						)}
					</div>
				</Tooltip>
			</div>
		</div>
	);
};
